(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mg-express-pay')){
    customElements.define('mg-express-pay',class extends HTMLElement{
      connectedCallback(){
        if(this.hasAttribute('data-visible'))return;
        this.observer=new IntersectionObserver(entries=>{
          if(entries.some(entry=>entry.isIntersecting)){
            this.setAttribute('data-visible','');
            this.observer.disconnect();
          }
        },{threshold:0.5});
        this.observer.observe(this);
      }
      disconnectedCallback(){this.observer?.disconnect()}
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mg-bundle-preview"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mg-product-bundle')){
    customElements.define('mg-product-bundle',class extends HTMLElement{
      connectedCallback(){
        if(this.dataset.ready){
          window.addEventListener('pageshow',this.restoreBundleState);
          return;
        }
        this.dataset.ready='true';
        const data=JSON.parse(this.querySelector('[data-bundle-data]').textContent);
        const addButton=this.querySelector('[data-bundle-add]');
        const status=this.querySelector('.mg-bundle__status');
        let selectedCount='2';
        let busy=false;
        let failed=false;
        this.restoreBundleState=event=>{
          if(!event.persisted)return;
          busy=false;
          failed=false;
          this.removeAttribute('aria-busy');
          addButton.disabled=!data[selectedCount].available;
          addButton.textContent=data[selectedCount].available?data.addLabel:data.unavailableLabel;
          this.querySelectorAll('[data-bundle-count]').forEach(tab=>{tab.disabled=false});
          status.hidden=true;
        };
        window.addEventListener('pageshow',this.restoreBundleState);
        this.querySelectorAll('[data-bundle-count]').forEach(button=>button.addEventListener('click',()=>{
          if(busy)return;
          const count=button.dataset.bundleCount;
          selectedCount=count;
          this.querySelectorAll('[data-bundle-count]').forEach(tab=>tab.setAttribute('aria-pressed',String(tab===button)));
          this.querySelector('[data-bundle-charger]').hidden=count!=='3';
          ['summary','original','total','saving'].forEach(key=>{this.querySelector('[data-bundle-'+key+']').textContent=data[count][key]});
          addButton.disabled=failed||!data[count].available;
          addButton.textContent=data[count].available?data.addLabel:data.unavailableLabel;
        }));
        addButton.addEventListener('click',async()=>{
          if(busy||failed||!data[selectedCount].available)return;
          busy=true;
          addButton.disabled=true;
          addButton.textContent=data.addingLabel;
          this.setAttribute('aria-busy','true');
          this.querySelectorAll('[data-bundle-count]').forEach(tab=>{tab.disabled=true});
          status.hidden=true;
          try{
            const response=await fetch(data.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:data[selectedCount].items})});
            const result=await response.json();
            if(!response.ok||result.status)throw new Error('cart_add_failed');
            window.location.assign(data.cartUrl);
          }catch(error){
            failed=true;
            busy=false;
            this.removeAttribute('aria-busy');
            addButton.textContent=data.addLabel;
            this.querySelectorAll('[data-bundle-count]').forEach(tab=>{tab.disabled=false});
            this.querySelector('[data-bundle-error]').textContent=data.errorLabel;
            status.hidden=false;
          }
        });
      }
      disconnectedCallback(){
        window.removeEventListener('pageshow',this.restoreBundleState);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
